export enum GreetingPreference {
  SORENSON_GREETING = '1',
  CUSTOM_GREETING = '2',
  CUSTOM_GREETING_WITH_TEXT = '3',
  TEXT_ONLY = '4',
}
